module.exports = __webpack_public_path__ + "static/media/Program2.b993a526.jpg";